import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { listBookActivitiesQueryKey } from "@modules/bookActivities/services/queries";
import { useCreateBookActivityMutation } from "@modules/bookActivities/services/mutations";
import { BookActivityFormValues, bookActivitySchema } from "@modules/bookActivities/validations";

export function useCreateBookActivityModal(modalRef: RefObject<ModalRef>, onComplete: () => void) {
  const queryClient = useQueryClient();
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<BookActivityFormValues>({
    resolver: zodResolver(bookActivitySchema()),
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useCreateBookActivityMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listBookActivitiesQueryKey,
        refetchType: 'all',
      });

      open?.({
        type: "success",
        message: translate("book_activity_admin.success.create"),
      });

      onComplete();
      modalRef.current?.close();
    },
  });

  return {
    methods,
    mutateAsync,
    isPending,
  };
}
